// Stub for Host — xtracker runs as a azathoth legacy app, no host bridge.
var Host = function(){
	var me = {};
	me.useUrlParams = false;
	me.useDropbox = false;
	me.showInternalMenu = false;
	me.useWebWorkers = false;
	me.useInitialLoad = false;
	me.initialFile = "";

	me.init = function(){};
	me.getBaseUrl = function(){ return ""; };
	me.getRemoteUrl = function(){ return ""; };
	me.getVersionNumber = function(){ return "xtracker"; };
	me.getBuildNumber = function(){ return "xtracker"; };
	me.signalReady = function(){};
	me.openUrl = function(url){ if (typeof window !== "undefined") window.open(url, "_blank"); };
	return me;
}();

export default Host;
